var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 6.66667V5.33333C11.3334 3.49238 9.84097 2 8.00002 2C6.15907 2 4.66669 3.49238 4.66669 5.33333V6.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 9.66669V11M5.86669 14H10.1334C11.2535 14 11.8135 14 12.2413 13.782C12.6177 13.5903 12.9236 13.2843 13.1154 12.908C13.3334 12.4802 13.3334 11.9201 13.3334 10.8V9.86669C13.3334 8.74658 13.3334 8.18653 13.1154 7.75871C12.9236 7.38238 12.6177 7.07642 12.2413 6.88467C11.8135 6.66669 11.2535 6.66669 10.1334 6.66669H5.86669C4.74658 6.66669 4.18653 6.66669 3.75871 6.88467C3.38238 7.07642 3.07642 7.38238 2.88467 7.75871C2.66669 8.18653 2.66669 8.74658 2.66669 9.86669V10.8C2.66669 11.9201 2.66669 12.4802 2.88467 12.908C3.07642 13.2843 3.38238 13.5903 3.75871 13.782C4.18653 14 4.74658 14 5.86669 14Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/IconLock.e0f296974aa8cae11333d5f9a16e3791.svg";
export { ForwardRef as ReactComponent };